import * as actionTypes from "./actionTypes";
import * as apiCall from "../services/api";
import { API_BASE_URL } from "../config/apiConfig";

const isObjectEmpty = (objectName) => {
  return Object.keys(objectName).length === 0
}

export const getClassesSuccess = (data) => {
  const noClasses = isObjectEmpty(data.Data)
  return {
    type: actionTypes.GET_CLASSES,
    payload: {
      classes: noClasses ? [] : data.Data,
    },
  };
};

export const getClasses = () => async (dispatch) => {
  return await apiCall
    .axiosGet(`${API_BASE_URL}/GetCourses`)
    .then((response) => {
      if (response) {
        dispatch(getClassesSuccess(response.data));
      }
    })
    .catch((error) => {
      console.log('Error: ', error);
    });
};
